<template>
  <el-submenu v-if="menu.children && menu.children.length >= 1" :index="menu.id + ''">
    <template slot="title">
      <i :class="menu.icon" ></i>
      <span slot="title">{{menu.name}}</span>
    </template>
    <MenuTree v-for="item in menu.children" :key="item.id" :menu="item"></MenuTree>
  </el-submenu>
  <el-menu-item v-else :index="menu.id + ''" @click="handleRoute(menu)">
    <i :class="menu.icon"></i>
    <span slot="title">{{menu.name}}</span>
  </el-menu-item>
</template>

<script>
import { getIFrameUrl, getIFramePath } from '@/utils/iframe'
export default {
  name: 'MenuTree',
  props: {
    menu: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleRoute (menu) {
      // 添加需要缓存的组件
      this.$store.state.tab.key.push(menu.url.split('/')[menu.url.split('/').length-1])
      // 缓存数组去重
      let arr = Array.from(new Set(this.$store.state.tab.key))
      // 更改vuex中的数组
      this.$store.commit('updateKey',arr); 
      // 如果是嵌套页面，转换成iframe的path
      let path = getIFramePath(menu.url)
      if(!path) {
        path = menu.url
      }
      if(menu.isDrag === 1){
        this.$api.component.XyjPcRoutesPush(this, {componentName:menu.componentName,loadPath:"",chinesename:menu.name,processKey:menu.cid?menu.cid:menu.processKey}).then((res) => {
          localStorage.setItem('processErrorShow',0)
          this.$router.push("/" + path);
        }).catch((error) => {

        });
      }else{
        // 通过菜单URL跳转至指定路由
        path ? this.$router.push("/" + path) : false
      }
    }
  },
  created(){
  }
}
</script>

<style scoped lang="scss">
// .el-submenu, .el-menu-item {
//   background-color: #3c4b5a44;
// }
</style>



// WEBPACK FOOTER //
// src/components/MenuTree/index.vue